/* eslint-disable no-control-regex */
/* eslint-disable no-useless-escape */
export const validationEmail = (address) => {
    var mail_regex1 = new RegExp('(?:[-!#-\'*+/-9=?A-Z^-~]+\.?(?:\.[-!#-\'*+/-9=?A-Z^-~]+)*|"(?:[!#-\[\]-~]|\\\\[\x09 -~])*")@[-!#-\'*+/-9=?A-Z^-~]+(?:\.[-!#-\'*+/-9=?A-Z^-~]+)*');
    var mail_regex2 = new RegExp('^[^\@]+\@[^\@]+$');
    if (address.match(mail_regex1) && address.match(mail_regex2)) {
        // 全角チェック
        if (address.match(/[^a-zA-Z0-9\!\"\#\$\%\&\'\(\)\=\~\|\-\^\\\@\[\;\:\]\,\.\/\\\<\>\?\_\`\{\+\*\} ]/)) { return false; }
        // 末尾TLDチェック（〜.co,jpなどの末尾ミスチェック用）
        if (!address.match(/\.[a-z]+$/)) { return false; }
        return true;
    } else {
        return false;
    }
}

export const validationPassword = (password) => {
    if (password.length < 8) {
        return false;
    }
    if (password.match(/[^a-zA-Z0-9\!\"\#\$\%\&\'\(\)\=\~\|\-\^\\\@\[\;\:\]\,\.\/\\\<\>\?\_\`\{\+\*\} ]/)) {
        return false;
    }
    return true;
}

export const validationDate = (date) => {
    if (!date.match(/^\d{1,4}(\-|-)\d{1,2}\1\d{1,2}$/)) {
        return false;
    }

    const [year, month, day] = date.split(/\-|-/).map(v => parseInt(v, 10));

    const check = new Date(year, month-1, day);
    return year === check.getFullYear() &&
           (month - 1) === check.getMonth() &&
           day === check.getDate();
}

export const validationTime = (time) => {
    if(!time.match(/^([01]?[0-9]|2[0-3]):([0-5][0-9])$/)) {
        return false;
    }
    return true;
}

export const validationDatetime = (datetime) => {
    const temp = datetime.split(' ');
    if(!temp[1]) return false;
    return validationDate(temp[0]) && validationTime(temp[1]);
}

export const validationNumeric = (num) => {
    if(num === "") {
        return false;
    }
    var temp = num.toString();
    if(temp.match(/[^0-9]+/)) {
        return false;
    }
    return true;
}